export interface VehicleStatusSearchDTO {
  vrm: string;
  customerId?: number;
  perPage?: number;
  page?: number;
  relistable?: boolean;
  noMOT?: boolean;
}
